import { PATHS } from "../../constants/paths";
import {
  SFByBusinessCapabilityNavIcon,
  SFMarketJobFinderNavIcon,
  SFAllJobsNavIcon,
} from "@sf-core";
import { Claims } from "../../constants/claims";

const getNavDefs = ({
  t, // i18n translation function
}) => {
  return [
    {
      path: PATHS.PRIMARY_TEXT_PATH,
      permissions: [Claims.AdminDataSkillExtractionView],
      icon: <SFAllJobsNavIcon />,
      header: t("analyticsSkillExtractionRoutes.primaryText"),
      description: t("analyticsSkillExtractionRoutes.primaryText"),
      default: true,
    },
    {
      path: PATHS.SECONDARY_TEXT_PATH,
      permissions: [Claims.AdminDataSkillExtractionView],
      icon: <SFByBusinessCapabilityNavIcon />,
      header: t("analyticsSkillExtractionRoutes.secondaryText"),
      description: t("analyticsSkillExtractionRoutes.secondaryText"),
    },
    {
      path: PATHS.NEGATIVE_TEXT_PATH,
      permissions: [Claims.AdminDataSkillExtractionView],
      icon: <SFMarketJobFinderNavIcon />,
      header: t("analyticsSkillExtractionRoutes.negativeText"),
      description: t("analyticsSkillExtractionRoutes.negativeText"),
    },
  ];
};

export default getNavDefs;
